import { Box } from '@mui/material';
import Grid from '@mui/material/Grid';
import React, { useEffect, useState } from 'react';
import useMyMApi from "../../hooks/useMyMApi";
import useWebContext from '../../hooks/useWebContext';
import { MyMImage } from '../../ui-elements/MyMImage';
import { MyMLabel, MyMVariantLabel } from '../../ui-elements/MyMLabel';
import { MyMModal } from '../../ui-elements/MyMModal';
import { MyMProgress } from '../../ui-elements/MyMProgress';
import Preview, { previewModalSize } from '../MyM906_Preview/Preview';
import { MyMVariantButton } from '../../ui-elements/MyMButton';
import { useNavigate } from 'react-router-dom';
import { mediaQuery, useMediaQuery } from '../../hooks/useMediaQuery';

/** MyMine Version2.0 DigitalSolutionLv2_1画面新規追加
* DigitalSolutionLv2_1 Page Content
*/
export const DigitalSolutionLv2SubLv1 = () => {
  const screenId = 'MyM310';
  const { controlSettings, screenSettings, commonFiles } = useWebContext(screenId);
  const apiRequest = useMyMApi(screenId);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleModalClose = () => setIsModalOpen(false);
  const [isInitLoading, setIsInitLoading] = useState(true);
  const navigate = useNavigate();
  const isPc = useMediaQuery(mediaQuery.pc);
  const xsGrid0 = isPc ? 6 : 12;
  const xsGrid1 = isPc ? 3.75 : 0;
  const xsGrid2 = isPc ? 4.5 : 12;
  const xsGrid3 = isPc ? 4 : 12;
  const xsGrid4 = isPc ? 1.75 : 0;
  const xsGrid5 = isPc ? 8.5 : 12;
  const minWidthButton = isPc ? '350px' : '100%';
  const leftButton = isPc ? '10%' : '';

  /**
 * プレビュー処理
 */
  useEffect(() => {
    const endLoading = () => setIsInitLoading(false);
    apiRequest.requestJson('api/digital-solution/lv2-1', 'GET', endLoading, endLoading);
  }, [])

  if (isInitLoading)
    return <MyMProgress />

  return (
    <Grid container className='pb-4' >
      <Grid container>
        <Grid item xs={xsGrid0}>
          <MyMVariantLabel variant='h5'>{controlSettings.LabelList.lblTitle}</MyMVariantLabel>
          {controlSettings.LabelList.lblExplaination}
        </Grid>
        <Grid item xs={xsGrid0}>
        </Grid>
      </Grid>
      <Grid item xs={xsGrid4} />
      <Grid item xs={xsGrid5} >
        <Box sx={{padding:'1% 0 0 0'}}>
          <MyMLabel fontSize='1.2rem'>
            {controlSettings.LabelList.lblMainText1}
          </MyMLabel>
          <Box sx={{ padding: '1% 5%' }}>
            <Grid container>
              <Grid item xs={0.5}>
                <MyMLabel fontSize='1.2rem'>●</MyMLabel>
              </Grid>
              <Grid item xs={11.5}>
                <MyMLabel fontSize='1.2rem'>{controlSettings.LabelList.lblMainText2}</MyMLabel>
              </Grid>
            </Grid>
            <Grid container>
              <Grid item xs={0.5}>
                <MyMLabel fontSize='1.2rem'>●</MyMLabel>
              </Grid>
              <Grid item xs={11.5}>
                <MyMLabel fontSize='1.2rem'>{controlSettings.LabelList.lblMainText3}</MyMLabel>
              </Grid>
            </Grid>
          </Box>
        </Box>

        <Box
          sx={{
            minHeight: '120px'
            , zIndex: 'modal'
            , py: 1
            , px: 2
            , borderRadius: 1
            , backgroundColor: '#E8E8E8'
          }}
        >
          <Grid container sx={{mb:'15px'}}>
            <Grid item xs={xsGrid1}>
            </Grid>
            <Grid item xs={xsGrid2}>
              <MyMLabel fontSize='1.5rem' sx={{fontWeight: 'bold', position: 'relative', textAlign: 'center' }}>{controlSettings.LabelList.lblSolutionsProvidedByConSiteMinePlus}</MyMLabel>
            </Grid>
            <Grid item xs={xsGrid1}>
            </Grid>
          </Grid>
          <Grid container spacing={1}>
            <Grid item xs={xsGrid3}>
              <MyMLabel color='#DD4600' fontSize='1.5rem' sx={{ fontWeight: 'bold', textDecoration: 'underline' }}>
                <MyMImage screenId={screenId} filePath={controlSettings.ImageList.imgProductivity} height='50px' width='50px'></MyMImage>
                {controlSettings.LabelList.lblProductivity}
              </MyMLabel>

              <Grid container>
                <Grid item xs={0.5}>
                  <MyMLabel color='#DD4600' fontSize='1.2rem'>●</MyMLabel>
                </Grid>
                <Grid item xs={11.5}>
                  <MyMLabel color='#DD4600' fontSize='1.2rem'>{controlSettings.LabelList.lblProductivityParts1}</MyMLabel>
                </Grid>
              </Grid>
              <Grid container>
                <Grid item xs={0.5}>
                  <MyMLabel color='#DD4600' fontSize='1.2rem'>●</MyMLabel>
                </Grid>
                <Grid item xs={11.5}>
                  <MyMLabel color='#DD4600' fontSize='1.2rem'>{controlSettings.LabelList.lblProductivityParts2}</MyMLabel>
                </Grid>
              </Grid>
              <Grid container>
                <Grid item xs={0.5}>
                  <MyMLabel color='#DD4600' fontSize='1.2rem'>●</MyMLabel>
                </Grid>
                <Grid item xs={11.5}>
                  <MyMLabel color='#DD4600' fontSize='1.2rem'>{controlSettings.LabelList.lblProductivityParts3}</MyMLabel>
                </Grid>
              </Grid>
              <Grid container>
                <Grid item xs={0.5}>
                  <MyMLabel color='#DD4600' fontSize='1.2rem'>●</MyMLabel>
                </Grid>
                <Grid item xs={11.5}>
                  <MyMLabel color='#DD4600' fontSize='1.2rem'>{controlSettings.LabelList.lblProductivityParts4}</MyMLabel>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={xsGrid3}>
              <MyMLabel color='#588432' fontSize='1.5rem' sx={{ fontWeight: 'bold', textDecoration: 'underline' }}>
                <MyMImage screenId={screenId} filePath={controlSettings.ImageList.imgEfficiency} height='50px' width='50px'></MyMImage>
                {controlSettings.LabelList.lblEfficiency}
              </MyMLabel>

              <Grid container>
                <Grid item xs={0.5}>
                  <MyMLabel color='#588432' fontSize='1.2rem'>●</MyMLabel>
                </Grid>
                <Grid item xs={11.5}>
                  <MyMLabel color='#588432' fontSize='1.2rem'>{controlSettings.LabelList.lblEfficiencyParts1}</MyMLabel>
                </Grid>
              </Grid>
              <Grid container>
                <Grid item xs={0.5}>
                  <MyMLabel color='#588432' fontSize='1.2rem'>●</MyMLabel>
                </Grid>
                <Grid item xs={11.5}>
                  <MyMLabel color='#588432' fontSize='1.2rem'>{controlSettings.LabelList.lblEfficiencyParts2}</MyMLabel>
                </Grid>
              </Grid>
              <Grid container>
                <Grid item xs={0.5}>
                  <MyMLabel color='#588432' fontSize='1.2rem'>●</MyMLabel>
                </Grid>
                <Grid item xs={11.5}>
                  <MyMLabel color='#588432' fontSize='1.2rem'>{controlSettings.LabelList.lblEfficiencyParts3}</MyMLabel>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={xsGrid3}>
              <MyMLabel fontSize='1.5rem' sx={{ fontWeight: 'bold', textDecoration: 'underline' }}>
                <MyMImage screenId={screenId} filePath={controlSettings.ImageList.imgReliability} height='50px' width='50px'></MyMImage>
                {controlSettings.LabelList.lblReliability}
              </MyMLabel>
              <Grid container>
                <Grid item xs={0.5}>
                  <MyMLabel fontSize='1.2rem'>●</MyMLabel>
                </Grid>
                <Grid item xs={11.5}>
                  <MyMLabel fontSize='1.2rem'>{controlSettings.LabelList.lblReliabilityParts1}</MyMLabel>
                </Grid>
              </Grid>
              <Grid container>
                <Grid item xs={0.5}>
                  <MyMLabel fontSize='1.2rem'>●</MyMLabel>
                </Grid>
                <Grid item xs={11.5}>
                  <MyMLabel fontSize='1.2rem'>{controlSettings.LabelList.lblReliabilityParts2}</MyMLabel>
                </Grid>
              </Grid>
              <Grid container>
                <Grid item xs={0.5}>
                  <MyMLabel fontSize='1.2rem'>●</MyMLabel>
                </Grid>
                <Grid item xs={11.5}>
                  <MyMLabel fontSize='1.2rem'>{controlSettings.LabelList.lblReliabilityParts3}</MyMLabel>
                </Grid>
              </Grid>
              <Grid container>
                <Grid item xs={0.5}>
                  <MyMLabel fontSize='1.2rem'>●</MyMLabel>
                </Grid>
                <Grid item xs={11.5}>
                  <MyMLabel fontSize='1.2rem'>{controlSettings.LabelList.lblReliabilityParts4}</MyMLabel>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Grid container>
            <Grid item xs={xsGrid3}>
            </Grid>
            <Grid item xs={xsGrid3}>
              {screenSettings.IsLearnMore && (
                <MyMVariantButton onClick={() => navigate(`MyM312/${controlSettings.LabelList.lblSolutionsProvidedByConSiteMinePlus}`)}
                  sx={{
                    backgroundColor: '#7F7F7F',
                    color: 'white',
                    minWidth: minWidthButton,
                    fontSize: '1.2rem',
                    left: leftButton
                  }}
                >{controlSettings.LabelList.lblLearnMore}</MyMVariantButton>
              )}
            </Grid>
            <Grid item xs={xsGrid3}>
            </Grid>
          </Grid>
        </Box>
        <MyMModal
          open={isModalOpen}
          onClose={handleModalClose}
          {...previewModalSize}
        >
          <Preview fileId={commonFiles.DiffenceConsiteAndConsiteMineFileId} onPreviewFailed={handleModalClose} />
        </MyMModal>
      </Grid >
      <Grid item xs={xsGrid4} />
    </Grid >
  );
}

export default DigitalSolutionLv2SubLv1;